function _templateObject() {
  var data = _taggedTemplateLiteral(["\n   display: inline-block;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { InnerContentWrapper } from './InnerContentWrapper';
import { SiteFooterShell } from './siteFooter/SiteFooterShell';
import { SiteFooterLogoWrapper } from './siteFooter/SiteFooterLogoWrapper';
import { SiteFooterText } from './siteFooter/SiteFooterText';
import { SiteFooterCopyright } from './siteFooter/SiteFooterCopyright';
import { SiteFooterLink } from './siteFooter/SiteFooterLink';
var InlineBlockSpan = styled.span(_templateObject());

var SiteFooter = function SiteFooter(_ref) {
  var copyrightDate = _ref.copyrightDate,
      termsUrl = _ref.termsUrl,
      privacyUrl = _ref.privacyUrl;
  return /*#__PURE__*/React.createElement(SiteFooterShell, null, /*#__PURE__*/React.createElement(InnerContentWrapper, null, /*#__PURE__*/React.createElement(SiteFooterLogoWrapper, null, /*#__PURE__*/React.createElement(SiteFooterText, null, /*#__PURE__*/React.createElement(InlineBlockSpan, null, /*#__PURE__*/React.createElement(SiteFooterCopyright, {
    copyrightDate: copyrightDate
  })), /*#__PURE__*/React.createElement(InlineBlockSpan, null, /*#__PURE__*/React.createElement(SiteFooterLink, {
    rel: "noopener noreferrer",
    target: "_blank",
    href: termsUrl
  }, "Terms of Use"), /*#__PURE__*/React.createElement(SiteFooterLink, {
    rel: "noopener noreferrer",
    target: "_blank",
    href: privacyUrl
  }, "Privacy Policy"))))));
};

SiteFooter.defaultProps = {
  termsUrl: 'https://www.somos.com/terms-use',
  privacyUrl: 'https://www.somos.com/privacy-policy'
};
export { SiteFooterShell, SiteFooterLogoWrapper, SiteFooterText, SiteFooterCopyright, SiteFooterLink, SiteFooter };